export const DOCUMENT_TYPE_INVOICE = 'invoice'
